import { useEffect, useState } from 'react';
import StxIcon from 'images/stacks-stx-logo.svg';

import { assets } from '../../../constants/assets';
import useGetTokenMetadata from '../../../hooks/use-getTokenMetadata';
import { TokenAssetBase } from '../../../types/assetsMetadata';

export const useTokenData = (address?: string, contractName?: string) => {
  const { fetchTokenMetadata } = useGetTokenMetadata();
  const [tokenData, setTokenData] = useState<TokenAssetBase | undefined>(undefined);
  const cachedAsset = assets.find(
    (asset) => asset.contractName === contractName && asset.contractAddress === address
  );

  useEffect(() => {
    if (!cachedAsset && contractName) {
      fetchTokenMetadata(`${address}.${contractName}`, contractName).then(setTokenData);
    }
  }, []);

  if (!contractName)
    return {
      name: 'STX',
      symbol: 'STX',
      decimals: 6,
      image: StxIcon,
    };

  return cachedAsset || tokenData;
};
